import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import checkmark from '../../assets/images/checkmark.svg';
import animator from '../../helpers/animator';
import './MultiTabUserSelectPopup.scss';

import BaseComponent from '../../baseClasses/BaseComponent';

export class MultiTabUserSelectPopup extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { menuSearchRender: false, selectedTab: 'INTERNAL' };
    this.menuOptions = this.props.menuOptions;
    this.searchString = '';
    this.keyPressedMultiple = 0;
    this.selectedMenuItemIndex = -1;
    this.animator = new animator();
    this.blur = false;

    this.itemsHeight = this.props.allMenuOptions.length * 30;
    this.headingHeight = 30;
    this.innerPopupHeight = Math.min(this.itemsHeight + 20 + this.headingHeight, 247);
    this.popupHeight = this.innerPopupHeight + 20;
    this.scrollerHeight = this.innerPopupHeight - 30;
  }

  processSearchString(searchString) {
    this.selectedMenuItemIndex = -1;
    if (this.state.selectedMenuOption) {
      this.state.selectedMenuOption.keyboardSelected = false;
      this.disableHover = false;
    }

    let smo = null;
    const saveFirstItem = this.menuOptions && this.menuOptions.length > 0 &&
      this.menuOptions[0].type == 0 ? this.menuOptions[0] : null;
    this.menuOptions = this.props.menuOptions.filter((option, index) => {
      const foundOption = option.name.toLowerCase().indexOf(searchString) >= 0;
      if (foundOption && !smo) {
        smo = option;
      }
      return foundOption;
    });
    this.selectedMenuItemIndex = 0;
    if (saveFirstItem) {
      this.menuOptions.splice(0, 0, saveFirstItem);
      this.selectedMenuItemIndex++;
    }
    if (!smo && this.menuOptions.length > 0) {
      smo = this.menuOptions[0];
    }
    if (smo) {
      let arrayLoc = this.keyPressedMultiple < this.menuOptions.length ? this.keyPressedMultiple : this.menuOptions.length;
      smo = this.menuOptions[arrayLoc];
      smo.keyboardSelected = true;
      this.disableHover = true;
      this.ensureItemVisible('option-' + (smo.optionId != undefined ? smo.optionId : smo.type));
      this.setState({ selectedMenuOption: smo });
      this.selectMenuItem(smo.type, false, smo, true);
      this.resizeMenu();
    }
  }

  initializeMenu() {
    this.menuContainer = document.getElementById(this.props.menuId);
    const rect = this.menuContainer.getBoundingClientRect();

    if (this.props.left >= 0) {
      this.menuContainer.style.left = (rect.left + (this.props.left < 0 && this.props.left > -10 ? this.props.left : 0)) + 'px';
    }

    // Don't set this yet. Will be set by animator  
    //    this.menuContainer.style.height = this.endHeight + "px"

    if (this.props.top) {
      let actualTop = rect.top;
      let actualBottom = (window.innerHeight - actualTop) + this.props.top - 15;
      if (rect.height > 0 && rect.bottom - rect.top < this.popupHeight) {
        actualTop = rect.bottom - this.popupHeight - 28;
        actualTop += 6;
      }

      if (actualTop + this.popupHeight > window.innerHeight) {
        this.menuContainer.style.bottom = actualBottom + 'px';
        this.setState({ forgetTop: true });
      }
      else {
        if (this.props.multiSelect) {
          this.setState({ forgetTop: false });
        }
        this.menuContainer.style.top = actualTop + 'px';
        this.menuContainer.style.bottom = '';
      }
    }
    else if (this.props.bottom) {
      const bottom = (window.innerHeight - rect.top) - 38;
      this.menuContainer.style.bottom = bottom + 'px';

    }
  }

  resizeMenu() {
    // this.menuContainer = document.getElementById(this.props.menuId)
    // this.menuContainer.style.height = this.popupHeight + "px"
    // this.setState({ menuHeight: this.popupHeight })
  }

  relocateMenu() {
    this.menuContainer.remove();
    this.pageBackground.remove();
  }

  componentDidMount() {
    // pop the menu out to the body element
    const bodyElement = document.body;
    this.menuContainer = document.getElementById(this.props.menuId);
    this.pageBackground = document.getElementById('multi-tab-popup-background');
    if (this.pageBackground) {
      bodyElement.appendChild(this.pageBackground);
    }
    if (this.menuContainer) {
      this.initializeMenu();
      bodyElement.appendChild(this.menuContainer);
      if (this.animator.hasAnimations) {
        // start the animation in a timer thread
        const self = this;
        setTimeout(() => {
          self.animator.processAnimationQueue(() => {
            self.displayed = true;

            self.handleFinishDisplay();
          });
        }, 10);
      }
    }

    this.setFocus();
  }

  setFocus() {
    if (this.mainMenu) {
      this.mainMenu.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
      this.mainMenu.focus();
    }
    if (this.searchInput) {
      this.searchInput.focus();
    }
  }

  handleFinishDisplay() {
    this.blur = true;
    //this.mainMenu.addEventListener("blur", this.handleBlur)
    this.setFocus();
  }

  componentWillUnmount() {
    // this.mainMenu.removeEventListener("blur", this.handleBlur)

    if (!this.hidden) {
      this.animateHide(null, true);
    }
    this.relocateMenu();
  }

  componentDidUpdate() {
    if (!this.animated && this.animator.hasAnimations) {
      this.animated = true;
      // start the animation in a timer thread
      const self = this;
      setTimeout(() => {
        self.animator.processAnimationQueue(() => {
          self.handleFinishDisplay();
        });
      }, 10);
    }
    else {
      this.setFocus();
    }
  }

  ensureItemVisible(id) {
    let element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
      var parentElement = element.parentElement;
      var rect = element.getBoundingClientRect();
      var parentRect = parentElement.getBoundingClientRect();
      var scrollRect = this.mainMenu.getBoundingClientRect();
      if (rect.top <= scrollRect.top) {
        this.mainMenu.scrollTop = (parentRect.top - rect.top) - rect.height;
      }
      else if (rect.bottom >= scrollRect.bottom) {
        this.mainMenu.scrollTop = (scrollRect.top - parentRect.top) + rect.height;
      }
    }
  }

  selectMenuItem(type, dismiss, menuOption, keyboardSelected) {
    if (this.props.multiSelect) {
      if (menuOption) {
        if (menuOption.selected) {
          menuOption.selected = false;
        }
        else {
          menuOption.selected = true;
        }
        const selectedMenuOptions = this.menuOptions.filter(mo => {
          return mo.selected;
        });
        if (this.props.handleMultiMenuSelection) {
          this.props.handleMultiMenuSelection(selectedMenuOptions, menuOption);
        }
        this.setState({
          refresh: !this.state.refresh,
        });
      }
    }
    else {
      if (!dismiss) {
        if (this.props.handleMenuSelection) {
          this.props.handleMenuSelection(type, keyboardSelected);
        }
        this.blur = false;
        this.setState({
          refresh: !this.state.refresh,
        });
      }
      else {
        if (keyboardSelected) {
          if (this.props.handleMenuSelection) {
            this.relocateMenu();
            this.props.handleMenuSelection(type, false);
            if (this.props.handleClickAway) {
              this.props.handleClickAway(this.props.menuId, !type);
            }
          }
        }
        else {
          this.blur = true;
          this.setState({ showMenuPoup: false });
          this.animateHide(type);
        }
      }
    }
  }

  handleMenuItemClick(e) {
    e.stopPropagation();
    const type = e.target.getAttribute('data-id');
    if (type) {
      const value = e.target.getAttribute('data-dismiss');
      const menuItem = this.menuOptions.filter(menuOption => {
        return menuOption.type.toString() == type.toString();
      });
      const dismiss = (value == 'true');
      this.selectMenuItem(type, dismiss, menuItem.length > 0 ? menuItem[0] : null);

      this.setFocus();
    }
  }

  animateHide(type, immediate) {
    this.hidden = true;
    let { menuId } = this.props;

    const element = document.getElementById(menuId);
    
    const ani = this.animator.createPropertyAnimation(menuId, 150,
        { height: { startVal: this.popupHeight, endVal: 0 } });
    this.animator.addAnimation(ani);

    if (immediate && element) {
      element.parentElement.removeChild(element);
      const clonedElement = element.cloneNode(true);
      const bodyElement = document.body;
      bodyElement.appendChild(clonedElement);

      this.animator.processAnimationQueue(() => {
        bodyElement.removeChild(clonedElement);
      });
    }
    else {
      // start the animation in a timer thread
      const self = this;
      setTimeout(() => {
        self.animator.processAnimationQueue(() => {
          if (self.props.handleMenuSelection && type) {
            self.props.handleMenuSelection(type);

          }
          self.props.handleClickAway(self.props.menuId, false);
        }, 10);
      });
    }

  }

  handleBlur(e) {
    if (this.blur) {
      this.animateHide();
    }
    else {
      if (this.mainMenu) {
        this.mainMenu.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
        this.mainMenu.focus();
      }
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }
    this.blur = false;
  }

  handleBackgroundClick(e) {
    this.animateHide();
  }

  handleKeyDown(e) {
    if (this.props.multiSelect) {
      return;
    }
    this.disableHover = false;
    let changedIt = false;
    if (e.keyCode == 8) {
      e.stopPropagation();
      if (this.searchString.length > 0) {
        this.searchString = this.searchString.substr(0, this.searchString.length - 1);
        changedIt = true;
      }
    }
    else if (e.keyCode == 13 || e.keyCode == 9) {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectedMenuItemIndex >= 0 && this.selectedMenuItemIndex < this.menuOptions.length) {
        this.selectMenuItem(this.menuOptions[this.selectedMenuItemIndex].type, true, null, true);
      }
      this.selectedMenuItemIndex = -1;
    }
    else if (e.keyCode == 27) {
      e.stopPropagation();
      this.selectedMenuItemIndex = -1;
      this.blur = true;
      this.setState({ showMenuPoup: false });
      this.animateHide(null);
    }
    // Up arrow  
    else if (e.keyCode == 38) {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectedMenuItemIndex > 0) {
        if (this.state.selectedMenuOption) {
          this.state.selectedMenuOption.keyboardSelected = false;
        }
        this.selectedMenuItemIndex--;
        let smo = this.menuOptions[this.selectedMenuItemIndex];
        smo.keyboardSelected = true;
        this.disableHover = true;
        this.resizeMenu();
        this.ensureItemVisible('option-' + (smo.optionId != undefined ? smo.optionId : smo.type));
        this.setState({ selectedMenuOption: smo });
        this.selectMenuItem(smo.type, false, smo, true);
      }
    }
    // Down arrow  
    else if (e.keyCode == 40) {
      e.stopPropagation();
      e.preventDefault();
      if (this.selectedMenuItemIndex < this.menuOptions.length - 1) {
        if (this.state.selectedMenuOption) {
          this.state.selectedMenuOption.keyboardSelected = false;
          this.disableHover = false;
        }
        this.selectedMenuItemIndex++;
        let smo2 = this.menuOptions[this.selectedMenuItemIndex];
        smo2.keyboardSelected = true;
        this.disableHover = true;
        this.resizeMenu();
        this.ensureItemVisible('option-' + (smo2.optionId != undefined ? smo2.optionId : smo2.type));
        this.setState({ selectedMenuOption: smo2 });
        this.selectMenuItem(smo2.type, false, smo2, true);
      }
    }
    else {
      e.stopPropagation();
      if (e.key.length == 1) {
        if (this.searchString == e.key.toLowerCase()) {
          this.keyPressedMultiple++;
        } else {
          this.keyPressedMultiple = 0;
          this.searchString += e.key.toLowerCase();
        }
        changedIt = true;
      }
    }

    if (changedIt) {
      this.processSearchString(this.searchString);
    }
    this.setFocus();
  }

  handleLink(e) {
    e.stopPropagation();
    let link = null;
    const type = e.target.getAttribute('data-id');
    for (var i = 0; i < this.menuOptions.length; i++) {
      if (type == this.menuOptions[i].type) {
        link = this.menuOptions[i].link;
        break;
      }
    }
    if (link) {
      this.props.history.push({ pathname: link });
    }
  }

  handleTabClick(e) {
    this.setState({ selectedTab: e.target.innerText });
    switch (e.target.innerText) {
    case 'INTERNAL':
      this.menuOptions = this.props.menuOptions;
      break;
    case 'VENDOR':
      this.menuOptions = this.props.vendorMenuOptions ? this.props.vendorMenuOptions : [];
      break;
    case 'ALL':
      this.menuOptions = this.props.allMenuOptions ? this.props.allMenuOptions : [];
      break;  
    default:
      break;
    }
  }

  render() {
    let { menuId, top, left, right, bottom, size } = this.props;
    this.state.menuSearchRender = false;

    if (this.state.forgetTop) {
      top = null;
    }

    const self = this;

    let optionClassName = 'menu-option ' + (size != undefined ? size : 'large');
    let menuOptionsFilter = this.menuOptions.filter(option => {
      return option.type;
    });

    let menuItems = menuOptionsFilter.map(option => {
      if (option.type == undefined) {
        return null;
      }

      let keyboardSelectedClass = '';
      let dismiss = true;
      if (option.keyboardSelected) {
        keyboardSelectedClass = ' keyboard-selected';
      }
      else if (this.disableHover) {
        keyboardSelectedClass = ' disable-hover';
      }
      if (option.dismiss == false) {
        dismiss = false;
      }

      const optionId = option.optionId != undefined ? option.optionId : option.type;
      const separatorClass = option.separated ? ' separated' : '';
      return (
        <div id={'option-' + optionId} className={optionClassName + keyboardSelectedClass + separatorClass} key={option.type} onClick={self.handleMenuItemClick}
          data-id={optionId} >
          {option.icon && (<img className="menu-icon" alt={option.name} src={option.icon} data-id={optionId} />)}
          {option.customIcon && (<div className="custom-menu-icon" data-id={optionId}>{option.customIcon}</div>)}
          <p className="menu-text" data-id={optionId} data-dismiss={dismiss}>{option.name}</p>
          {option.decoration && (<img alt="decoration" className="menu-decoration" src={option.decoration} />)}
          {option.selected && (<img className="selected-img" src={checkmark} alt="selected" />)}
        </div>
      );
    });

    let popupStyle = {};
    let style = { height: this.innerPopupHeight };
    let scrollerStyle = { height: this.scrollerHeight };
    let innerStyle = { top: 0, left: 0, height: this.itemsHeight };
    if (top) {
      popupStyle.top = top - 10;
    }
    else if (bottom != undefined) {
      popupStyle.bottom = bottom + 10;
    }
    if (left != undefined) {
      if (left + 258 + 20 > window.innerWidth) {
        left = window.innerWidth - 258 - 20;
      }
      popupStyle.left = left - 10;
    }
    if (right != undefined) {
      popupStyle.right = right + 10;
    }

    if (!this.displayed) {
      if (!this.props.initialValue) {
        popupStyle.height = 0;  // change it to the starting value
        if (!this.animator.hasAnimations) {
          const ani = this.animator.createPropertyAnimation(menuId, 150,
            { height: { startVal: 0, endVal: this.popupHeight } });
          this.animator.addAnimation(ani);
        }
      }
    }
    else {
      popupStyle.height = this.popupHeight;
    }

    innerStyle.top = 0;
    innerStyle.left = 0;

    let background = null;
    if (!this.props.noBackground) {
      background = <div id="multi-tab-popup-background" className={'multi-tab-popup-background'} onClick={this.handleBackgroundClick} ref={(element) => {
        this.outerMenu = element;
      }} >
      </div>;

    }
    return (
      <div>
        {background}
        <div className='outer-multi-tab-popup-container' style={popupStyle} id={menuId} >
          <div className='multi-tab-popup-menu-container' style={style} data-id={menuId + '-outer'}>
            <div className='tab-heading'>
              <div id='internal-users' className={'tab' + (this.state.selectedTab == 'INTERNAL' ? ' selected' : '')} onClick={this.handleTabClick}>INTERNAL</div>
              <div id='vendor-users' className={'tab' + (this.state.selectedTab == 'VENDOR' ? ' selected' : '')} onClick={this.handleTabClick}>{this.textMap.vendor.toUpperCase()}</div>
              <div id='all-users' className={'tab' + (this.state.selectedTab == 'ALL' ? ' selected' : '')} onClick={this.handleTabClick}>ALL</div>
            </div>    
            <div id={'main-menu-' + menuId} className='menu-multi-tab-popup-scroller' style={scrollerStyle}>
              <div className='menu-item-container' style={innerStyle} onKeyDown={this.handleKeyDown} ref={(element) => {
                this.mainMenu = element;
              }} >
                {menuItems.length ? menuItems : <p className='no-notify-users'>No available {this.state.selectedTab.toLowerCase()} users</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(withRouter(MultiTabUserSelectPopup));



// WEBPACK FOOTER //
// ./src/components/MultiTabUserSelectPopup/index.js